

import React, { useState, useRef, useEffect } from 'react';
import { Box, Button, Typography, TextField, IconButton, Stack } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
// import CustomInput from '../CustomInput/CustomInput';
import CustomInputLogin from '../../Components/CustomInputLogin/CustomInputLogin';
import { useNavigate } from 'react-router-dom';
import actions from '../../ReduxStore/actions';
import { useDispatch, useSelector } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';


const ChangePassword = ({ toggleForgotPassword, handleGoRegistrationPage }) => {
    const { getUserById } = useSelector(state => state?.getUserById);

    const validationSchema = Yup.object({
        email: Yup.string().email('Invalid email').required('Email is required'),
        // old_password: Yup.string().required('Old password is required'),
        new_password: Yup.string()
            .required('New password is required')
            .min(8, 'Password must be at least 8 characters')
            .matches(/[A-Z]/, 'Must contain an uppercase letter')
            .matches(/[a-z]/, 'Must contain a lowercase letter')
            .matches(/[0-9]/, 'Must contain a number')
            .matches(/[@$!%*?#^()&]/, 'Must contain a special character'),
        retype_password: Yup.string()
            .required('Please retype your password')
            .oneOf([Yup.ref('new_password'), null], 'Passwords must match')
    });
    const navigate = useNavigate()
    const handleCancelNavigate = () => {
        navigate("/user")
    }
    const dispatch = useDispatch()
    const sessionUserId = sessionStorage.getItem("userId")
    useEffect(() => {
        const fetchData = async () => {
            const data1 = {
                data: {},
                method: "get",
                apiName: `getUserById/${sessionUserId}`,
            };
            const response = await dispatch(actions.GETUSERBYID(data1));
        }
        fetchData()
    }, [])

    const handleSubmit = async (values) => {
        const data1 = {
            data: {
                password: values?.new_password

            },
            method: "put",
            apiName: `editUserInfo/${sessionUserId}`,
        };
        const response = await dispatch(actions.EDITUSERINFO(data1));
        if (response?.payload?.message === "User information updated successfully.") {
            toast?.success("Password change successfully")
            setTimeout(() => {
                navigate("/user")

            }, 2500)
        } else {
            toast.error("Passwordd not changed")
        }

    }



    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
            sx={{ backgroundColor: '#f9f9f9', px: 2 }} // optional background and padding
        >
            <Box width="100%" maxWidth="350px" sx={{ background: "white", p: 4 }}>
                <Typography variant="h4" textAlign="center" sx={{ fontSize: "30px", fontWeight: "600", mb: 4, display: { xs: "none", md: "block" } }}>
                    Change Password
                </Typography>
                <Formik
                    enableReinitialize
                    initialValues={{
                        email: getUserById.data?.personal_email || '',
                        // old_password: '',
                        new_password: '',
                        retype_password: '',
                    }}
                    validationSchema={validationSchema}
                    onSubmit={(values, { setFieldError }) => {
                        handleSubmit(values);
                    }}

                >
                    {({ errors, touched, handleChange }) => (
                        <Form style={{ width: '100%' }}>
                            <Box mb={2}>
                                <CustomInputLogin name="email" label="Email" custPlaceholder="Enter Email" inputType="text" disabled />
                            </Box>

                            {/* <Box mb={2}>
                                <CustomInputLogin name="old_password" label="Old Password" custPlaceholder="Enter Old Password" inputType="password" />
                            </Box> */}

                            <Box mb={2}>
                                <CustomInputLogin name="new_password" label="New Password" custPlaceholder="Enter New Password" inputType="password" />
                            </Box>
                            <Box mb={2}>
                                <CustomInputLogin name="retype_password" label="Retype Password" custPlaceholder="Enter Retype Password" inputType="password" />
                            </Box>


                            <Stack sx={{ display: "flex", justifyContent: "space-between", flexDirection: "row" }}>
                                <Button
                                    fullWidth
                                    // type="submit"
                                    onClick={handleCancelNavigate}
                                    variant="contained"
                                    sx={{
                                        // borderRadius: 23,
                                        mt: 2,
                                        mr: 1,
                                        py: "7px",
                                        color: "black",
                                        backgroundColor: "white"
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    fullWidth
                                    type="submit"
                                    variant="contained"
                                    sx={{
                                        // borderRadius: 23,
                                        mt: 2,
                                        py: "7px",
                                        color: "white",
                                        backgroundColor: "var(--main-color)"
                                    }}
                                >
                                    Update
                                </Button>
                            </Stack>
                        </Form>
                    )
                    }
                </Formik >
            </Box>
            <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
            />
        </Box>
    );
};

export default ChangePassword;
